import { http } from "./config";
import authHeader from "./auth-header";

const URL_BASE = "/servico-cemiteriais";

export default {
  usuario_logado: () => {
    return http.get("/usuario/logado", {
      headers: authHeader(),
    });
  },

  listar: (params) => {
    return http.get(URL_BASE, {
      params,
      headers: authHeader(),
    });
  },

  exportar_fluxo_cemiterial_xls: (params = {}) => {
    return http.get(`${URL_BASE}/tickets-xls`, {
      params,
      headers: authHeader(),
      responseType: "blob",
    });
  },

  listar_etapas: () => {
    return http.get(`${URL_BASE}/etapas`, {
      headers: authHeader(),
    });
  },

  listar_autorizacoes: () => {
    return http.get(`${URL_BASE}/autorizacoes`, {
      headers: authHeader(),
    });
  },

  buscar_por_id: (ticketId) => {
    return http.get(`${URL_BASE}/${ticketId}`, {
      headers: authHeader(),
    });
  },

  buscar_historico: (ticketId) => {
    return http.get(`${URL_BASE}/${ticketId}/historico`, {
      headers: authHeader(),
    });
  },

  atualizar_servico: (id, dto) => {
    return http.put(`${URL_BASE}/${id}`, dto, {
      headers: authHeader(),
    });
  },

  atribuir_responsavel: (ticketId, etapaId) => {
    return http.post(`${URL_BASE}/atribuir`, null, {
      params: {
        ticketId,
        etapaId,
      },
      headers: authHeader(),
    });
  },

  sincronizar_itens: (ticketId) => {
    return http.post(`${URL_BASE}/${ticketId}/itens`, null, {
      headers: authHeader(),
    });
  },

  etapa_atividades: (ticketFunerarioEtapaId) => {
    return http.get(
      `${URL_BASE}/etapa-atividades/ticket-etapa/${ticketFunerarioEtapaId}`,
      {
        headers: authHeader(),
      },
    );
  },

  atividades_etapa: (etapaId) => {
    return http.get(`${URL_BASE}/atividades/etapa/${etapaId}`, {
      headers: authHeader(),
    });
  },

  adicionar_atividade: (dto) => {
    return http.post(`${URL_BASE}/etapa-atividades`, dto, {
      headers: authHeader(),
    });
  },
  editar_atividade: (dto, id) => {
    return http.put(`${URL_BASE}/etapa-atividades/${id}`, dto, {
      headers: authHeader(),
    });
  },

  excluir_atividade: (id) => {
    return http.delete(`${URL_BASE}/etapa-atividades/${id}`, {
      headers: authHeader(),
    });
  },
};
